import React, { useMemo, useState, useEffect } from "react";
import moment from "moment";
import staffApi from "../../api/user/staff.api";
import { useNavigate } from "react-router-dom";

const fetchAllStaffDetails = async (ids) => {
  const staffMap = {};

  await Promise.all(
    ids.map(async (id) => {
      const { response, err } = await staffApi.getStaffInfo(id);
      // console.log({ response });
      if (response && response.data) {
        const staff = response.data.data; // ✅ fixed here

        staffMap[id] = staff;
      } else {
        console.warn("Failed to fetch staff with ID:", id, err);
      }
    })
  );

  return staffMap;
};

const TopTeamMember = ({ bookings = [] }) => {
  const [updatedStaffMap, setUpdatedStaffMap] = useState({});

  useEffect(() => {
    const uniqueProIds = [
      ...new Set(
        bookings.map((b) => b.selectedProfessional?._id).filter(Boolean)
      ),
    ];

    if (uniqueProIds.length > 0) {
      fetchAllStaffDetails(uniqueProIds).then(setUpdatedStaffMap);
    }
  }, [bookings]);

  const teamStats = useMemo(() => {
    const thisMonth = moment().format("YYYY-MM");
    const lastMonth = moment().subtract(1, "month").format("YYYY-MM");

    const stats = {};

    bookings.forEach((booking) => {
      const month = moment(booking.createdAt).format("YYYY-MM");
      const proId = booking.selectedProfessional?._id;
      if (!proId || !updatedStaffMap[proId]) return;

      const staff = updatedStaffMap[proId];
      const totalServices =
        (booking.selectedNailServices?.length || 0) +
        (booking.selectedBeautyServices?.length || 0);

      if (!stats[proId]) {
        stats[proId] = {
          _id: proId,
          name: staff.name,
          photo: staff.photo,
          thisMonth: 0,
          lastMonth: 0,
        };
      }

      if (month === thisMonth) stats[proId].thisMonth += totalServices;
      else if (month === lastMonth) stats[proId].lastMonth += totalServices;
    });

    return Object.values(stats).sort((a, b) => b.thisMonth - a.thisMonth);
  }, [bookings, updatedStaffMap]);

  const navigate = useNavigate();

  return (
    <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-lg shadow border border-border">
      <div className="overflow-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left border-b border-textGray text-yellowdark">
              <th className="pb-2">Team member</th>
              <th className="pb-2">This month</th>
              <th className="pb-2">Last month</th>
            </tr>
          </thead>
          <tbody>
            {teamStats.map((item) => (
              <tr
                key={item._id}
                role="button"
                tabIndex={0}
                className="border-b border-border text-text cursor-pointer hover:bg-white/5 transition duration-150 select-none"
                onClick={() => navigate(`/staff/preview/${item._id}`)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(`/staff/preview/${item._id}`);
                  }
                }}
              >
                <td className="py-2 flex items-center gap-2">
                  <img
                    src={item.photo}
                    alt={item.name}
                    className="w-8 h-8 rounded-full object-cover"
                  />
                  {item.name}
                </td>
                <td className="py-2">{item.thisMonth} services</td>
                <td className="py-2">{item.lastMonth} services</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TopTeamMember;
